import React, { useState, useEffect } from "react";
import _ from "lodash";

const CollapseText = ({ params, class_name, description, challenge_id }) => {
  const view_more = _.get(params, "view_more", "View more");
  const view_less = _.get(params, "view_less", "View less");

  const [isExpanded, setIsExpanded] = useState(false);
  const [isViewMore, setIsViewMore] = useState(false);

  useEffect(() => {
    let description_height = document.getElementById(challenge_id).offsetHeight;
    if (description_height > 65) {
      setIsViewMore(true);
    }
  }, [challenge_id]);

  return (
    <div
      className={`desc-container ${isExpanded ? "expanded" : ""} ${
        class_name ? class_name : ""
      }`}
    >
      <p
        id={challenge_id}
        className={`challenge-description ${isViewMore ? "overflow" : ""} ${
          isExpanded ? "expanded" : ""
        }`}
      >
        {description}
      </p>
      {isViewMore && (
        <div className={`view-more-container ${isExpanded ? "expanded" : ""}`}>
          {!isExpanded && <span>...</span>}
          <span
            className={`view-more-text ${isExpanded ? "expanded" : ""}`}
            onClick={() => setIsExpanded((prev) => !prev)}
          >
            {isExpanded ? view_less : view_more}
          </span>
        </div>
      )}
    </div>
  );
};

export default CollapseText;
